import { useEffect, useRef, useState } from 'react';
import {
  Box,
  Card,
  Table,
  Button,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Grid,
  TextField,
  InputAdornment,
  Avatar,
} from '@mui/material';
import { Link, Link as RouterLink } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import Label from '../../components/Label';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
// import Searchbar from '../../components/Searchbar';
import { useAppDispatch, useAppSelector } from '../../store';
import { findToppingsCategoryItem } from '../../store/toppingsCategoryItem/api';
import {
  setCurrentPage,
  setLimit,
  setSkip,
} from '../../store/toppingsCategoryItem/toppingsCategoryItemSlice';
import Loader from '../../components/Loader';
import {
  // reset as resetToppingsCategoryItem,
  setStatus as setToppingsCategoryItemStatus,
} from '../../store/toppingsCategoryItem/toppingsCategoryItemSlice';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { encryptString, getAssetURl } from '../../utils/url';
import AutoComplete from '../../components/AutoComplete';
import {
  findSelectToppingsCategory,
  searchSelectToppingsCategory,
} from '../../store/selectToppingCategory/api';
import { uniqBy } from 'lodash';
import {
  setSkip as setSkipToppingsCategory,
  reset as resetToppingsCategory,
} from '../../store/selectToppingCategory/selectToppingCategorySlice';
import CloseIcon from '@mui/icons-material/Close';

const Index = () => {
  const dispatch = useAppDispatch();
  const { data, totalRecords, limit, currentPage, skip, isLoading } =
    useAppSelector((state) => state.toppingsCategoryItem);
  const [search, setSearch] = useState<string>('');
  const [toppingCategoryId, setToppingCategoryId] = useState<string>('');
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  useEffect(() => {
    dispatch(
      findToppingsCategoryItem({
        limit,
        skip,
        ...(search && { search: search }),
        ...(toppingCategoryId && { toppingCategoryId: toppingCategoryId }),
      })
    );
  }, [dispatch, limit, skip, toppingCategoryId, search]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ): void => {
    dispatch(setSkip({ skip: limit * newPage }));
    dispatch(setCurrentPage({ currentPage: newPage }));
    dispatch(setToppingsCategoryItemStatus({ status: 'idle' }));
  };
  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    dispatch(setLimit({ limit: +event.target.value }));
  };

  // Topping Category Data
  const {
    data: toppingCategoryData,
    isLoading: isToppingCategoryLoading,
    skip: toppingCategorySkip,
    hasMore: toppingCategoryHasMore,
    status: toppingCategoryStatus,
  } = useAppSelector((state) => state.selectToppingsCategory);

  useEffect(() => {
    if (toppingCategoryStatus === 'idle') {
      dispatch(
        findSelectToppingsCategory({
          limit: 10,
          skip: toppingCategorySkip,
        })
      );
    }
  }, [toppingCategorySkip, toppingCategoryStatus]);

  const onScrollFetchToppingsCategory = (
    e: React.UIEvent<HTMLUListElement, UIEvent>,
    search: string
  ) => {
    if (
      e.currentTarget.scrollTop + 300 >= e.currentTarget.scrollHeight &&
      toppingCategoryHasMore
    ) {
      dispatch(setSkipToppingsCategory({ skip: toppingCategorySkip + 10 }));
      dispatch(
        findSelectToppingsCategory({
          limit: 10,
          skip: toppingCategorySkip + 10,
          ...(search && { search: search }),
        })
      );
    }
  };

  const searchToppingsCategory = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!e.target.value) {
      dispatch(resetToppingsCategory());
      return;
    }
    const params = {
      ...(!e.target.value && { limit: 10 }),
      ...(!e.target.value && { skip: 0 }),
      ...(e.target.value && { search: e.target.value }),
    };
    dispatch(setSkipToppingsCategory({ skip: 0 }));
    dispatch(searchSelectToppingsCategory(params));
  };

  const uniqueToppingsCategoryData = uniqBy([...toppingCategoryData], 'id');

  const boxRef = useRef<HTMLDivElement>(null);
  const [openLightBox, setOpenLightBox] = useState(false);
  const [imageState, setImageState] = useState<string>();

  const handleOpenLightBox = (imageObject: string) => {
    setOpenLightBox(true);
    setImageState(imageObject);
  };

  const handleCloseLightBox = () => {
    setOpenLightBox(false);
    setImageState('');
  };

  return (
    <Page title={'Toppings Category Item: List'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={'Toppings Category Item'}
          links={[{ name: 'Dashboard', href: '/' }]}
          action={
            <Button
              variant='contained'
              component={RouterLink}
              to={'/toppings-category-item/create'}
              startIcon={<Iconify icon={'eva:plus-fill'} />}
            >
              {'New Toppings Category Item'}
            </Button>
          }
        />

        <Card>
          <Grid
            container
            spacing={2}
            sx={{ py: 2.5, px: 3 }}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <AutoComplete
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                  } else if (newValue) {
                    setToppingCategoryId(newValue.id);
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  if (!newInputValue) {
                    setToppingCategoryId('');
                  }
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.labelEn}</li>
                )}
                getOptionLabel={(option) => option.labelEn}
                fetchFunction={onScrollFetchToppingsCategory}
                label={'Topping Category'}
                loading={isToppingCategoryLoading}
                options={uniqueToppingsCategoryData}
                searchFunction={searchToppingsCategory}
                value={
                  uniqueToppingsCategoryData?.filter(
                    (toppingCategory) =>
                      toppingCategory.id === toppingCategoryId
                  )?.[0] || null
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <TextField
                fullWidth
                onChange={(e) => setSearch(e.target.value)}
                placeholder={'Search...'}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <Iconify
                        icon={'eva:search-fill'}
                        sx={{ color: 'text.disabled', width: 20, height: 20 }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 1000, position: 'relative' }}>
              <Table size={'medium'}>
                <TableHead>
                  <TableRow>
                    <TableCell align='center'>{'Image'}</TableCell>
                    <TableCell align='center'>{'Topping Category'}</TableCell>
                    <TableCell align='center'>{'Label EN'}</TableCell>
                    <TableCell align='center'>{'Label AR'}</TableCell>
                    <TableCell align='center'>{'Position'}</TableCell>
                    <TableCell align='center'>{'Price'}</TableCell>
                    {/* <TableCell align='center'>{'Country'}</TableCell>
                    <TableCell align='center'>{'Code'}</TableCell> */}
                    <TableCell align='center'>{'Status'}</TableCell>
                    <TableCell align='center'>{'Action'}</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading ? (
                    <TableRow hover>
                      <TableCell
                        colSpan={8}
                        align='center'
                      >
                        <Loader />
                      </TableCell>
                    </TableRow>
                  ) : data?.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align='center'
                      >
                        {'No record found'}
                      </TableCell>
                    </TableRow>
                  ) : (
                    data?.map((toppingsCategoryItem) => (
                      <TableRow key={toppingsCategoryItem.id}>
                        <TableCell
                          align='center'
                          sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                          {toppingsCategoryItem?.previewUrl && (
                            <Avatar
                              onClick={() =>
                                handleOpenLightBox(
                                  toppingsCategoryItem?.previewUrl
                                )
                              }
                              alt={toppingsCategoryItem?.previewUrl}
                              imgProps={{ crossOrigin: 'anonymous' }}
                              src={getAssetURl(
                                toppingsCategoryItem?.previewUrl,
                                assetUrl
                              )}
                              sx={{
                                borderRadius: 'unset',
                                m: 1,
                                objectFit: 'contain',
                                '& img': { objectFit: 'contain' },
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell align='center'>
                          <Stack
                            direction='row'
                            spacing={0.5}
                            justifyContent='center'
                            flexWrap='wrap'
                            useFlexGap
                          >
                            {toppingsCategoryItem?.topping_category?.labelEn && (
                              <Chip
                                label={toppingsCategoryItem.topping_category.labelEn}
                                size='small'
                                color='primary'
                                variant='outlined'
                              />
                            )}
                            {toppingsCategoryItem?.additionalCategories?.map(
                              (ac: any) =>
                                ac?.toppingCategory?.labelEn && (
                                  <Chip
                                    key={ac.id}
                                    label={ac.toppingCategory.labelEn}
                                    size='small'
                                    variant='outlined'
                                  />
                                )
                            )}
                          </Stack>
                        </TableCell>
                        <TableCell align='center'>
                          {toppingsCategoryItem?.labelEn}
                        </TableCell>
                        <TableCell align='center'>
                          {toppingsCategoryItem?.labelAr}
                        </TableCell>
                        <TableCell align='center'>
                          {toppingsCategoryItem?.position}
                        </TableCell>
                        <TableCell align='center'>
                          {toppingsCategoryItem?.price}
                        </TableCell>
                        {/* <TableCell align='center'>
                          {region?.country?.labelEn}
                        </TableCell>
                        <TableCell align='center'>{region?.code}</TableCell> */}
                        <TableCell align='center'>
                          <Label
                            variant='ghost'
                            color={
                              toppingsCategoryItem.activeState
                                ? 'success'
                                : 'error'
                            }
                          >
                            {toppingsCategoryItem.activeState
                              ? 'Active'
                              : 'InActive'}
                          </Label>
                        </TableCell>
                        <TableCell align='center'>
                          <IconButton aria-label='visibility'>
                            <Link
                              to={`/toppings-category-item/edit/${encryptString(
                                toppingsCategoryItem?.id ?? ''
                              )}`}
                              state={{ ...toppingsCategoryItem }}
                              style={{ color: '#808080' }}
                            >
                              <Iconify icon={'eva:edit-fill'} />
                            </Link>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component='div'
              count={totalRecords}
              rowsPerPage={limit}
              page={Math.min(Math.round(totalRecords / limit), currentPage)}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </Box>
        </Card>
      </Container>

      {openLightBox && (
        <Box
          sx={{ pt: 'env(safe-area-inset-top) !important' }}
          id='myModal'
          className='modal'
        >
          <span className='close cursor'>
            <CloseIcon
              fontSize='large'
              onClick={handleCloseLightBox}
              sx={{ mt: 'env(safe-area-inset-top) !important' }}
            />
          </span>
          <div
            className={`modal-content ${
              openLightBox ? 'display-block ' : 'display-none'
            }`}
          >
            {imageState && (
              <div className='vertical-center-div'>
                <div
                  ref={boxRef}
                  className={`mySlides ${
                    openLightBox ? 'display-block ' : 'display-none'
                  }`}
                >
                  <img
                    id={imageState}
                    src={getAssetURl(imageState, assetUrl)}
                    width='100%'
                    height='100%'
                    crossOrigin='anonymous'
                    alt={imageState}
                  />
                </div>
              </div>
            )}
          </div>
        </Box>
      )}
    </Page>
  );
};

export default Index;
